(function () {
  if (window.__obInit) return; window.__obInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.ob-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Gauge ---------- */
  var CX = 150, CY = 150, R = 120, START = -210, SWEEP = 240, GID = 0;
  function ang(v, max) { return START + SWEEP * Math.max(0, Math.min(v, max)) / max; }
  function pt(a, r) { var t = a * Math.PI / 180; return [CX + r * Math.cos(t), CY + r * Math.sin(t)]; }

  function buildGauge(g) {
    if (g.dataset.built) return; g.dataset.built = '1';
    var from = +g.dataset.from || 25, to = +g.dataset.to || 45, max = +g.dataset.max || 50;
    var svg = g.querySelector('svg'), ticks = g.querySelector('.ob-g-ticks');
    var id = 'obg' + (++GID);
    var gr = svg.querySelector('.ob-g-grad'), ng = svg.querySelector('.ob-g-ngrad'), bg = svg.querySelector('.ob-g-bgrad');
    gr.id = id + 'a'; ng.id = id + 'n'; bg.id = id + 'b';
    var boost = svg.querySelector('.ob-g-boost'), glow = svg.querySelector('.ob-g-glow'), base = svg.querySelector('.ob-g-werk');
    var needle = svg.querySelector('.ob-g-needle');
    boost.style.stroke = 'url(#' + gr.id + ')';
    svg.querySelector('.ob-g-needle-body').style.fill = 'url(#' + ng.id + ')';
    svg.querySelector('.ob-g-bg').style.fill = 'url(#' + bg.id + ')';
    var html = '', step = max <= 40 ? 2 : 2.5;
    for (var v = 0; v <= max + 0.001; v += step) {
      var a = ang(v, max), major = Math.abs(v % 10) < 0.001, isB = v > from && v <= to, isW = v <= from;
      var p1 = pt(a, R + 15), p2 = pt(a, R + (major ? 27 : 21));
      html += '<line class="ob-g-tick' + (major ? ' is-major' : '') + (isB ? ' is-boost' : '') + (isW ? ' is-werk' : '') + '" x1="' + p1[0].toFixed(1) + '" y1="' + p1[1].toFixed(1) + '" x2="' + p2[0].toFixed(1) + '" y2="' + p2[1].toFixed(1) + '"/>';
      if (major) { var pl = pt(a, R - 26); html += '<text x="' + pl[0].toFixed(1) + '" y="' + (pl[1] + 4).toFixed(1) + '" text-anchor="middle" class="ob-g-lbl' + (isB ? ' is-boost' : '') + '">' + v + '</text>'; }
    }
    ticks.innerHTML = html;
    var fp = from / max * 100, tp = to / max * 100;
    boost.style.strokeDashoffset = -fp; glow.style.strokeDashoffset = -fp;
    var hotT;
    function rot(v) { needle.style.transform = 'rotate(' + ang(v, max) + 'deg)'; }
    function set(state) {
      var tuned = state === 'tuned';
      var d = (tuned ? (tp - fp) : 0) + ' 100';
      boost.style.strokeDasharray = d; glow.style.strokeDasharray = d;
      rot(tuned ? to : from);
      base.style.strokeDasharray = fp + ' 100'; g.classList.add('is-on');
      g.classList.toggle('is-tuned', tuned);
      g.classList.remove('is-hot'); clearTimeout(hotT);
      if (tuned && !reduce) hotT = setTimeout(function () { g.classList.add('is-hot'); }, 900);
      var wrap = g.closest('.ob-gauge-wrap');
      if (wrap) wrap.querySelectorAll('[data-ob-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.obToggle === state ? 'true' : 'false'); });
    }
    rot(0);
    var wrap = g.closest('.ob-gauge-wrap');
    if (wrap) wrap.querySelectorAll('[data-ob-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { set(b.dataset.obToggle); });
    });
    g.addEventListener('mouseenter', function () { if (g.classList.contains('is-tuned') && !reduce) { rot(max); setTimeout(function () { rot(to); }, 350); } });
    var go = function () {
      if (reduce) return set('tuned');
      rot(max);                                   /* startup sweep */
      setTimeout(function () { set('werk'); }, 700);
      setTimeout(function () { set('tuned'); }, 1700);
    };
    if (!('IntersectionObserver' in window)) return go();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: .45 });
    io.observe(g);
  }

  /* ---------- Tabs ---------- */
  function tabs(root) {
    (root || document).querySelectorAll('[data-ob-tabs]').forEach(function (t) {
      if (t.dataset.built) return; t.dataset.built = '1';
      var btns = t.querySelectorAll('[role=tab]'), panels = t.querySelectorAll('[role=tabpanel]');
      function sel(i, focus) {
        btns.forEach(function (b, j) { b.setAttribute('aria-selected', i === j); b.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; if (i === j) p.querySelectorAll('.ob-gauge').forEach(buildGauge); });
        if (focus) btns[i].focus();
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { sel(i); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') sel((i + 1) % btns.length, true);
          if (e.key === 'ArrowLeft') sel((i - 1 + btns.length) % btns.length, true);
        });
      });
      sel(0);
    });
  }

  function init(root) {
    reveal(root); tabs(root);
    (root || document).querySelectorAll('.ob-gauge').forEach(function (g) { if (!g.closest('[hidden]')) buildGauge(g); });
  }
  window.obInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
